import React, { useState } from 'react'
import styles from './MovieCard.module.scss'
import ImageWithFallback from 'components/ImageWithFallback/ImageWithFallback'
import { StarIcon, FilmIcon, PlayIcon, HeartIcon } from '../../../../../components/CustomIcons'

const MovieCard = ({ 
  movie, 
  onClick, 
  onToggleFavorite, 
  onRate, 
  isFavorite = false, 
  viewMode = 'grid' 
}) => {
  const [showRating, setShowRating] = useState(false)
  const [userRating, setUserRating] = useState(movie.user_rating || 0)

  const handleStarClick = (rating) => {
    setUserRating(rating)
    onRate(rating)
    setShowRating(false)
  }

  const formatRating = (rating) => {
    if (!rating) return 'N/A'
    const numRating = parseFloat(rating)
    return !isNaN(numRating) ? numRating.toFixed(1) : 'N/A'
  }

  const formatYear = (date) => {
    return date ? new Date(date).getFullYear() : 'N/A'
  }

  const getImageUrl = (path) => {
    if (!path) return '/placeholder-movie.jpg'
    if (path.startsWith('http')) return path
    return `https://security.ncore.kg${path}`
  }

  return (
    <div className={`${styles.movieCard} ${styles[viewMode]}`}>
      <div className={styles.posterContainer} onClick={onClick}>
        <ImageWithFallback
          src={getImageUrl(movie.poster)}
          alt={movie.name || movie.title}
          className={styles.poster}
          fallbackIcon={<FilmIcon size={48} />}
          fallbackText="Нет постера"
        />
        
        <div className={styles.overlay}>
          <div className={styles.playButton}>
            <PlayIcon size={40} />
          </div>
          <div className={styles.overlayInfo}>
            <h4>{movie.name || movie.title}</h4>
            <p>{formatYear(movie.release_date)}</p>
          </div>
        </div>

        <div className={styles.favoriteButton} onClick={(e) => {
          e.stopPropagation()
          onToggleFavorite()
        }}>
          <HeartIcon size={20} style={{ color: isFavorite ? '#ff4444' : '#999' }} />
        </div>
      </div>

      <div className={styles.movieInfo}>
        <h3 className={styles.title} onClick={onClick}>{movie.name || movie.title}</h3>

        <div className={styles.metadata}>
          <span className={styles.year}>{formatYear(movie.release_date)}</span>
          {movie.type && (
            <span className={styles.type}>
              {movie.type === 'movie' ? <><FilmIcon size={14} style={{ marginRight: '4px' }} /> Фильм</> : <><FilmIcon size={14} style={{ marginRight: '4px' }} /> Сериал</>}
            </span>
          )}
        </div>

        <div className={styles.genres}>
          {movie.categories_names?.slice(0, 3).map((categoryName, index) => (
            <span key={index} className={styles.genre}>
              {categoryName}
            </span>
          ))}
        </div>

        <div className={styles.ratings}>
          <div className={styles.averageRating}>
            <span className={styles.ratingValue}>
              <StarIcon size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />{formatRating(movie.rating_avg)}
            </span>
            <span className={styles.voteCount}>
              ({movie.reviews_count || 0} отзывов)
            </span>
          </div>

          <div className={styles.userRatingContainer}>
            <button 
              className={styles.rateButton}
              onClick={() => setShowRating(!showRating)}
            >
              {userRating > 0 ? `Моя оценка: ${userRating}/10` : 'Оценить'}
            </button>

            {showRating && (
              <div className={styles.ratingStars}>
                {[1, 2, 3, 4, 5].map(star => (
                  <button
                    key={star}
                    className={`${styles.star} ${star <= userRating ? styles.filled : ''}`}
                    onClick={() => handleStarClick(star)}
                  >
                    ⭐
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {viewMode === 'list' && movie.description && (
          <p className={styles.overview}>
            {movie.description.length > 200 
              ? `${movie.description.substring(0, 200)}...` 
              : movie.description
            }
          </p>
        )}

        <div className={styles.actions}>
          <button className={styles.detailsButton} onClick={onClick}>
            Подробнее
          </button>
        </div>
      </div>
    </div>
  )
}

export default MovieCard